import { Box } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { dispatchAudioAnalytics } from '../../Analytics';
import backgroundAudio from '../../assets/audios/common.mp3';
import InfoImg from '../../assets/images/info.svg';
import InfoImgHover from '../../assets/images/info_hover.svg';
import AudioOff from '../../assets/images/sound_off.svg';
import AudioOffHover from '../../assets/images/sound_off_hover.svg';
import AudioOn from '../../assets/images/sound_on.svg';
import AudioOnHover from '../../assets/images/sound_on_hover.svg';
import { MapOverlayProps } from '../../interfaces/components';
import AudioToggleModal from '../../pages/AudioToggleModal';
import HoverImage from './HoverImage';
// import MapImg from '../../assets/images/map.svg';
// import MapImgHover from '../../assets/images/map_hover.svg';
import PassportImg from '../../assets/images/passport.svg';
import PassportImgHover from '../../assets/images/passport_hover.svg';
import LanguageSwitcher from './LanguageSwitcher';
import { disptchCTAClickObject } from '../../Analytics';
// import CreatedByEmperia from '../../assets/images/created_by_emperia.png';

const MapOverlay = ({
  toggleInstructions,
  openFirstModal,
  togglePassport,
  firstVisit,
  villageName,
}: MapOverlayProps) => {
  const [audioModal, setAudioModal] = useState(firstVisit);
  const [audioActive, setAudioActive] = useState(false);
  const myRef = useRef<HTMLAudioElement>(null);
  const [tabVisible, setTabVisible] = useState<boolean>(true);

  // EventListeners
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') setTabVisible(true);
    else setTabVisible(false);
  });

  useEffect(() => {
    if (audioActive && !tabVisible) {
      if (myRef.current) {
        myRef.current.pause();
        setAudioActive(false);
      }
    }
  }, [tabVisible]);

  const toggleAudio = () => {
    if (!audioActive) {
      if (myRef.current) {
        dispatchAudioAnalytics(true, 'Map');
        myRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (myRef.current) {
        dispatchAudioAnalytics(false, 'Map');
        myRef.current.pause();
        setAudioActive(false);
      }
    }
  };

  const playInitialAudio = (state: boolean) => {
    if (state) {
      if (myRef.current) {
        myRef.current.play();
        setAudioActive(true);
      }
    } else {
      if (myRef.current) {
        myRef.current.pause();
        setAudioActive(false);
      }
    }
    if (firstVisit) {
      openFirstModal();
    }
  };

  return (
    <Box className="layout">
      {/* Audio Layer */}
      <audio ref={myRef} src={backgroundAudio} />

      {/* Audio Popup */}
      <AudioToggleModal
        proceedAudio={(state: boolean) => {
          playInitialAudio(state);
          setAudioModal(false);
          dispatchAudioAnalytics(state, 'Map');
        }}
        active={audioModal}
      />

      {/* Right Floating Buttons */}
      <Box
        position="fixed"
        top={['40px', '30px', '25px']}
        right={['15px', '20px', '25px']}
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        zIndex={3}
      >
        {/* <HoverImage
          w={['40px', '40px', '50px']}
          h={['40px', '40px', '50px']}
          src={MapImg}
          hover={MapImgHover}
          onClick={() => console.log('')}
        /> */}
        {audioActive ? (
          <HoverImage
            w={['50px', '50px', '50px']}
            h={['50px', '50px', '50px']}
            src={AudioOn}
            hover={AudioOnHover}
            onClick={toggleAudio}
          />
        ) : (
          <HoverImage
            w={['50px', '50px', '50px']}
            h={['50px', '50px', '50px']}
            src={AudioOff}
            hover={AudioOffHover}
            onClick={toggleAudio}
          />
        )}
        <HoverImage
          w={['50px', '50px', '50px']}
          h={['50px', '50px', '50px']}
          src={InfoImg}
          hover={InfoImgHover}
          onClick={toggleInstructions}
        />
        <HoverImage
          w={['50px', '50px', '50px']}
          h={['50px', '50px', '50px']}
          src={PassportImg}
          hover={PassportImgHover}
          onClick={togglePassport}
        />
      </Box>

      <Box
        position="fixed"
        bottom={['20px', '20px', '25px']}
        left={['unset', 'unset', '25px']}
        right={['10px', '10px', 'unset']}
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={8}
      >
        <LanguageSwitcher
          onLanguageSelect={(name: string) => {
            disptchCTAClickObject(villageName, 'Button', 'LanguageSelect', name, '');
          }}
        />
      </Box>

      {/* Created By Emperia Link */}
      {/* <Link href="https://emperiavr.com/" target="_blank" tabIndex={-1} userSelect="none">
        <Box position="fixed" bottom={['15px', '20px', '25px']} right={['15px', '15px', '25px']} cursor="pointer">
          <Image src={CreatedByEmperia} width={['150px', '150px', '200px', '200px', '200px', '200px']} loading="lazy" />
        </Box>
      </Link> */}
    </Box>
  );
};

export default MapOverlay;
